"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveMinutes = void 0;
var tslib_1 = require("tslib");
var Types = tslib_1.__importStar(require("./model"));
var Service = tslib_1.__importStar(require("./service"));
exports.ActiveMinutes = tslib_1.__assign({ Types: Types }, Service);
